
import { useContext } from 'react';
import { Link, useParams } from 'react-router';

import logo from 'src/assets/images/logos/isotipo_microscopio.svg';
import SearchContext from 'src/context/SearchContext';
import SearchBox from 'src/components/SearchBox';
import EMenu from 'src/components/EMenu';

import 'src/css/Header.scss';

const Header = () => {
    const { isSearching, openMenu, setOpenMenu } = useContext(SearchContext);
    const { id } = useParams();
    return (
        <div id="header" className={` ${(isSearching || id) ? 'head-search' : ''}`}>
            <div className="logo">
                <Link to="/" discover="none" className="no-txt"> <span>Ir a Home</span> <img src={logo} alt="Logo"/> </Link>
                <div className="title">
                    <div>Microscopía virtual</div>
                    <div>y recursos para estudios de la salud</div>
                </div>
            </div>

            {(isSearching || id) && <SearchBox /> }

            <button className="btn-menu" onClick={() => setOpenMenu(p => !p)}>
                <span>Explorar</span>
                <span className={openMenu ? 'ico-f1n' : 'ico-f1s'}></span>
            </button>

            {openMenu && <EMenu/> }
        </div>
    );
};

export default Header;
